import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { TranslatePipe } from '../../../../../shared/pipes/translate.pipe';

/**
 * Formly field type for numeric input
 *
 * Props:
 * - label: string - Field label
 * - placeholder: string - Placeholder text
 * - description: string - Helper text
 * - required: boolean - Whether value is required
 * - min: number - Minimum value
 * - max: number - Maximum value
 * - step: number - Step increment (default: 1)
 */
@Component({
  selector: 'app-number-field',
  imports: [ReactiveFormsModule, FormlyModule, TranslatePipe],
  templateUrl: './number-field.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './number-field.component.css',
})
export class NumberFieldComponent extends FieldType<FieldTypeConfig> {}
